import { Clock } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

function getStatus(): { isOpen: boolean; message: string } {
  const now = new Date();
  const day = now.getDay(); // 0=Sunday
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const time = hours * 60 + minutes;

  // Sunday = closed, Mon-Sat = 11:15 to 23:15
  if (day === 0) {
    return { isOpen: false, message: "Fechado aos domingos" };
  }

  const open = 11 * 60 + 15;  // 11:15
  const close = 23 * 60 + 15; // 23:15

  if (time >= open && time < close) {
    const remaining = close - time;
    const h = Math.floor(remaining / 60);
    const m = remaining % 60;
    return {
      isOpen: true,
      message: h > 0 ? `Fecha em ${h}h${m > 0 ? `${m}min` : ""}` : `Fecha em ${m}min`,
    };
  }

  if (time < open) {
    return { isOpen: false, message: `Abre às 11:15` };
  }

  return { isOpen: false, message: "Abre amanhã às 11:15" };
}

export function RestaurantStatus() {
  const { ref, isVisible } = useScrollAnimation();
  const { isOpen, message } = getStatus();

  return (
    <div
      ref={ref}
      className={`bg-card border-y border-border text-card-foreground transition-all duration-500 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="container mx-auto px-4 py-3 flex items-center justify-center gap-3">
        <span className="relative flex h-3 w-3">
          <span
            className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
              isOpen ? "bg-green-400" : "bg-red-400"
            }`}
          />
          <span
            className={`relative inline-flex rounded-full h-3 w-3 ${
              isOpen ? "bg-green-500" : "bg-red-500"
            }`}
          />
        </span>
        <span className={`font-bold ${isOpen ? "text-green-500 dark:text-green-400" : "text-red-500 dark:text-red-400"}`}>
          {isOpen ? "Aberto agora" : "Fechado"}
        </span>
        <span className="text-gray-400 dark:text-gray-500">•</span>
        <span className="text-gray-800 dark:text-gray-200 font-medium flex items-center gap-1">
          <Clock className="h-4 w-4" />
          {message}
        </span>
        <span className="text-gray-400 dark:text-gray-500 hidden sm:inline">•</span>
        <span className="text-gray-800 dark:text-gray-200 font-medium text-sm hidden sm:inline">
          Seg a Sáb: 11:15 – 23:15
        </span>
      </div>
    </div>
  );
}
